/**
 * Constant values for Common
 */
/**
 * Keydown event trigger
 *
 * @hidden
 */
export var KEY_DOWN = 'keydown';
/**
 * Undo and Redo action HTML plugin events
 *
 * @hidden
 */
export var ACTION = 'action';
/**
 * Formats plugin events
 *
 * @hidden
 */
export var FORMAT_TYPE = 'format-type';
/**
 * Keydown handler event trigger
 *
 * @hidden
 */
export var KEY_DOWN_HANDLER = 'keydown-handler';
/**
 * List plugin events
 *
 * @hidden
 */
export var LIST_TYPE = 'list-type';
/**
 * Code Block plugin events
 *
 * @hidden
 */
export var CODE_BLOCK = 'code-block';
/**
 * Keyup handler event trigger
 *
 * @hidden
 */
export var KEY_UP_HANDLER = 'keyup-handler';
/**
 * Keyup event trigger
 *
 * @hidden
 */
export var KEY_UP = 'keyup';
/**
 * Model changed plugin event trigger
 *
 * @hidden
 */
export var MODEL_CHANGED_PLUGIN = 'model_changed_plugin';
/**
 * Model changed event trigger
 *
 * @hidden
 */
export var MODEL_CHANGED = 'model_changed';
/**
 * PasteCleanup plugin for MSWord content
 *
 * @hidden
 */
export var MS_WORD_CLEANUP_PLUGIN = 'ms_word_cleanup_plugin';
/**
 * PasteCleanup for MSWord content
 *
 * @hidden
 */
export var MS_WORD_CLEANUP = 'ms_word_cleanup';
/**
 * ActionBegin event callback
 *
 * @hidden
 */
export var ON_BEGIN = 'onBegin';
/**
 * Callback for spacelist action
 *
 * @hidden
 */
export var SPACE_ACTION = 'actionBegin';
/**
 * Format painter event constant
 *
 * @hidden
 */
export var FORMAT_PAINTER_ACTIONS = 'format_painter_actions';
/**
 * AI Assistant Event constant
 *
 * @hidden
 */
export var AI_ASSISTANT_ACTIONS = 'ai_assistant_actions';
/**
 * Blockquotes enter prevent when on list is applied event constant
 *
 * @hidden
 */
export var BLOCKQUOTE_LIST_HANDLE = 'blockquote_list_handled';
/**
 * Emoji picker event constant
 *
 * @hidden
 */
export var EMOJI_PICKER_ACTIONS = 'emoji_picker_actions';
/**
 * Auto format event constant
 *
 * @hidden
 */
export var AUTO_FORMAT_ACTIONS = 'auto_format_actions';
/**
 * Mouse down event constant
 *
 * @hidden
 */
export var MOUSE_DOWN = 'mouseDown';
/**
 * destroy event constant
 *
 * @hidden
 */
export var DESTROY = 'destroy';
/**
 * internal_destroy event constant
 *
 * @hidden
 */
export var INTERNAL_DESTROY = 'internal_destroy';
/**
 * code block indentation event constant
 *
 * @hidden
 */
export var CODEBLOCK_INDENTATION = 'codeblock_indentation';
/**
 * code block indentation event constant
 *
 * @hidden
 */
export var CODEBLOCK_DISABLETOOLBAR = 'codeblock_disabletoolbar';
/**
 * @hidden
 * @private
 */
export var CLS_RTE_TABLE_RESIZE = 'e-rte-table-resize';
/**
 * @hidden
 * @private
 */
export var CLS_TB_ROW_INSERT = 'e-tb-row-insert';
/**
 * @hidden
 * @private
 */
export var CLS_TB_COL_INSERT = 'e-tb-col-insert';
/**
 * @hidden
 * @private
 */
export var CLS_TB_DASH_BOR = 'e-dashed-border';
/**
 * @hidden
 * @private
 */
export var CLS_TB_ALT_BOR = 'e-alternate-border';
/**
 * @hidden
 * @private
 */
export var CLS_TB_COL_RES = 'e-column-resize';
/**
 * @hidden
 * @private
 */
export var CLS_TB_ROW_RES = 'e-row-resize';
/**
 * @hidden
 * @private
 */
export var CLS_TB_BOX_RES = 'e-table-box';
/**
 * @hidden
 * @private
 */
export var CLS_IMG_FOCUS = 'e-img-focus';
/**
 * @hidden
 * @private
 */
export var CLS_TABLE_SEL = 'e-cell-select';
/**
 * @hidden
 * @private
 */
export var CLS_TABLE_SEL_END = 'e-cell-select-end';
/**
 * @hidden
 * @private
 */
export var CLS_TABLE_MULTI_CELL = 'e-multi-cells-select';
export var CLS_AUD_FOCUS = 'e-audio-focus';
/**
 * @hidden
 * @private
 */
export var CLS_VID_FOCUS = 'e-video-focus';
/**
 * @hidden
 * @private
 */
export var CLS_RTE_DRAG_IMAGE = 'e-rte-drag-image';
/**
 * @hidden
 * @private
 */
export var CLS_RESIZE = 'e-resize';
/**
 * @hidden
 * @private
 */
export var hideTableQuickToolbar = 'hideTableQuickToolbar';
/**
 * @hidden
 * @private
 */
export var touchStart = 'touchStart';
/**
 * @hidden
 * @private
 */
export var touchEnd = 'touchEnd';
/**
 * @hidden
 * @private
 */
export var cut = 'cut';
/**
 * @hidden
 * @private
 */
export var dragEnterEvent = 'dragEnter_Event';
/**
 * @hidden
 * @private
 */
export var dragOverEvent = 'dragOver_Event';
/**
 * @hidden
 * @private
 */
export var dragStartEvent = 'dragStart_Event';
/**
 * @hidden
 * @private
 */
export var dropEvent = 'drop_Event';
/**
 * @hidden
 * @private
 */
export var dragEnter = 'dragEnter';
/**
 * @hidden
 * @private
 */
export var dragDrop = 'dragDrop';
/**
 * @hidden
 * @private
 */
export var dragOver = 'dragOver';
/**
 * @hidden
 * @private
 */
export var dropEventHandler = 'drop';
